import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { Team } from '@yandex-int/k-common/typings';
import b from 'b_';
import { Spin, Table, TableBody, TableCell, TableRow, Text, BackgroundImage } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/constants';
import { InjectedProps as WithRouterPath, withRouterPath } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import qs from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { bindActionCreators, Dispatch } from 'redux';

import ExternalLmsBadge from 'common.components/external-lms-badge/external-lms-badge';
import { teamBuilderActions } from 'common.components/team-builder/actions';
import { TEAM_BUILDER_ENTRY_STEPS } from 'common.components/team-builder/typings';
import * as userSelectors from 'common.components/user/selectors';
import * as coursesTemplatesActions from 'store/courses-templates/actions';
import * as coursesTemplatesSelectors from 'store/courses-templates/selectors';
import { CourseTemplateWithCourseData } from 'store/courses-templates/typings';
import { actions as coursesActions } from 'store/courses/actions';
import { getSubjects } from 'store/courses/selectors';
import { CourseSubject } from 'store/courses/typings';

// @ts-ignore
import AddButton from '../__add-button/class__add-button';
import { ReduxTeacherStore, RootAction } from '../../../typings';
// @ts-ignore
import { shouldShowSubjectsEmptyState } from '../selectors';

import './class__subjects.scss';

interface StoreProps {
    teamId: number | null;
    currentClass: Team | null;
    isArchiveClass: boolean;
    isExternalClass: boolean;
    loadingStatus: LOADING_STATUSES;
    templates: Array<CourseTemplateWithCourseData>;
    shouldShowEmptyState: boolean;
    subjects: Array<CourseSubject>;
    isGradeAvailable: boolean;
}

interface DispatchProps {
    getCoursesSubjectsByTeamRequest: typeof coursesActions.getCoursesSubjectsByTeamRequest;
    getCoursesTemplates: typeof coursesTemplatesActions.getCoursesTemplatesRequest;
    startTeamBuilder: typeof teamBuilderActions.start;
}

interface OwnProps extends WithRouterPath {}

interface ClassSubjectsProps extends StoreProps, DispatchProps, OwnProps {}

interface State {
    promoteSubjectAddition: boolean;
}

export class ClassSubjects extends React.Component<ClassSubjectsProps, State> {
    static contextTypes = {
        staticUrls: PropTypes.shape({
            labSubjectLessonsComplete: PropTypes.string.isRequired,
        }),
    };

    state = {
        promoteSubjectAddition: false,
    };

    componentDidMount(): void {
        const { teamId, getCoursesTemplates, history } = this.props;

        if (teamId) {
            getCoursesTemplates({ classId: teamId });

            this.loadCoursesSubjects();
        }

        const { promoAddSubject, ...restSearchParams } = qs.parse(location.search);

        if (promoAddSubject) {
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({ promoteSubjectAddition: true });

            history.replace({
                search: qs.stringify(restSearchParams, { arrayFormat: 'bracket' }),
            });
        }
    }

    componentDidUpdate(prevProps: Readonly<ClassSubjectsProps>): void {
        const { teamId: prevTeamId, subjects: prevSubjects } = prevProps;
        const { teamId, getCoursesTemplates, subjects } = this.props;

        if (prevTeamId !== teamId && teamId) {
            getCoursesTemplates({ classId: teamId });

            this.loadCoursesSubjects();
        }

        if (prevSubjects.length !== subjects.length && teamId) {
            getCoursesTemplates({ classId: teamId });

            this.loadCoursesSubjects();
        }
    }
    context!: React.ContextType<React.Context<{ staticUrls: Record<string, string> }>>;

    loadCoursesSubjects = () => {
        const { getCoursesSubjectsByTeamRequest, isExternalClass, teamId } = this.props;

        if (teamId && isExternalClass) {
            getCoursesSubjectsByTeamRequest({ teamId });
        }
    };

    openLessons = (subject: SUBJECTS_SLUGS) => {
        const { history, getRouterPath, isArchiveClass } = this.props;
        const {
            staticUrls: { labSubjectLessonsComplete },
        } = this.context;

        if (!isArchiveClass) {
            history.push(getRouterPath(labSubjectLessonsComplete, { subject: subject }));
        }
    };

    handleAddSubject = () => {
        const { shouldShowEmptyState, startTeamBuilder } = this.props;

        ym('reachGoal', 'teacher_my_students_class_my_subjects_add', {
            amount: shouldShowEmptyState ? 'from_empty_state' : 'one_more_subject',
        });

        startTeamBuilder({
            entryPoint: TEAM_BUILDER_ENTRY_STEPS.SUBJECTS,
        });
    };

    // eslint-disable-next-line complexity
    render() {
        const { loadingStatus, templates, isArchiveClass, currentClass, isGradeAvailable } = this.props;
        const { promoteSubjectAddition } = this.state;

        if (!currentClass) {
            return null;
        }

        const isLoading = loadingStatus === LOADING_STATUSES.LOADING;
        const isLoaded = loadingStatus === LOADING_STATUSES.SUCCESS;
        const shouldShowEmptyState =
            isLoaded && (templates.length === 0 || templates.every((template) => !template.is_assigned));
        const shouldShowAddButton = !isArchiveClass && isLoaded && templates.some((template) => !template.is_assigned);
        const shouldShowContent = isLoaded && !shouldShowEmptyState;

        return (
            <Table mix="class__subjects">
                <TableBody mix="class__subjects-table-body">
                    {isLoading && <Spin center />}
                    {shouldShowContent &&
                        templates.map((template) => {
                            if (!template.is_assigned) {
                                return null;
                            }

                            return (
                                <TableRow
                                    contentMix="class__subject"
                                    disabled={isArchiveClass}
                                    key={template.id}
                                    onClick={() => this.openLessons(template.subject)}
                                >
                                    <TableCell>
                                        {template.cover && (
                                            <BackgroundImage
                                                layout={BackgroundImage.LAYOUT.STATIC}
                                                mix="class__subject-image"
                                                src={template.cover.file}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        <Text weight={Text.WEIGHT.M}>{template.name}</Text>
                                    </TableCell>
                                    {template.externalCourse && (
                                        <TableCell>
                                            <ExternalLmsBadge
                                                mix="class__subject-external-badge"
                                                textId={`class.subjects.externalBadge.${template.externalCourse.lms}`}
                                                theme={ExternalLmsBadge.THEME.EXPANDED}
                                            />
                                        </TableCell>
                                    )}
                                </TableRow>
                            );
                        })}
                    {shouldShowEmptyState && (
                        <div className="class__empty-state">
                            <Text
                                id={
                                    isGradeAvailable
                                        ? 'class.subjects.emptyState'
                                        : 'class.subjects.emptyState.gradeUnavailable'
                                }
                                size={Text.SIZE.XL}
                                type={TEXT_MARKUP_TYPE.MARKDOWN}
                                values={{
                                    name: currentClass.name,
                                    level: currentClass.level,
                                }}
                            />
                        </div>
                    )}
                    {shouldShowAddButton && (
                        <AddButton
                            mix={b('class', 'subjects-add-button', { promo: promoteSubjectAddition })}
                            onClick={this.handleAddSubject}
                            textId="class.button.addSubject"
                        />
                    )}
                </TableBody>
            </Table>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: OwnProps): StoreProps => {
    const {
        match: {
            params: { classId: classIdFromMatch },
        },
    } = ownProps;
    const classId = Number(classIdFromMatch);

    return {
        teamId: classId,
        currentClass: userSelectors.getCurrentClass(storeState, { classId }),
        isArchiveClass: userSelectors.getIsCurrentClassArchived(storeState, { classId }),
        isExternalClass: userSelectors.getIsCurrentClassExternal(storeState, { classId }),
        loadingStatus: coursesTemplatesSelectors.getCoursesTemplatesLoadingStatus(storeState, { classId }),
        shouldShowEmptyState: shouldShowSubjectsEmptyState(storeState, { classId }),
        subjects: getSubjects(storeState, { classId }),
        templates: coursesTemplatesSelectors.getCoursesTemplatesWithExternalCourseData(storeState, { classId }),
        isGradeAvailable: userSelectors.getIsCurrentClassNumberAvailable(storeState, { classId }),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps =>
    bindActionCreators(
        {
            getCoursesSubjectsByTeamRequest: coursesActions.getCoursesSubjectsByTeamRequest,
            getCoursesTemplates: coursesTemplatesActions.getCoursesTemplatesRequest,
            startTeamBuilder: teamBuilderActions.start,
        },
        dispatch
    );

export default withRouterPath(connect(mapStateToProps, mapDispatchToProps)(ClassSubjects));
